<template>
    <v-card>
        <v-app-bar
         class="rounded-0"
         color="#98494C"
         elevation="0"
         :height="resizeHeight"
         flat>
            <a href="https://aichi-fk.jp" style="height: 28px">
                <img src="../assets/logo.png" style="height: 28px" transition="fade-transition" />
            </a>
        </v-app-bar>
    </v-card>
</template>

<script>
    export default {
        name: 'Header',

        data: function() {
            return {
                width: window.innerWidth
            }
        },

        computed: {
            resizeHeight: function() {
                if(this.width < 960)
                    return "48px"
                return "72px"
            }
        },

        methods: {
            handleResize: function() {
                this.width = window.innerWidth;
            },
        },

        mounted: function() {
            window.addEventListener('resize', this.handleResize)
        },

        beforeDestroy: function() {
            window.removeEventListener('resize', this.handleResize)
        }
    }
</script>

<style scoped>

</style>
